import Breadcrumbs from 'Components/Breadcrumbs'
import CustomButton from 'Components/CustomButton'
import ListActions from 'Components/ListActions'
import ListSearch from 'Components/ListSearch'
import TariffImportDialog from 'Services/ProductManagement/Features/Tariff/Components/TariffImportDialog'
import TariffList from 'Services/ProductManagement/Features/Tariff/Components/TariffList'
import { TariffContext } from 'Services/ProductManagement/Features/Tariff/Context/tariffContext'
import { useTariffsWithParams } from 'Services/ProductManagement/Features/Tariff/Hooks'
import {
  ENABLE_TARIFF_IMPORT,
  PRODUCT_MANAGEMENT_ROOT_URL,
  ROWS_PER_PAGE_DEFAULT
} from 'Util/constants'
import useListFunctions from 'Util/hooks/useListFunctions'
import AddIcon from '@mui/icons-material/Add'
import UploadIcon from '@mui/icons-material/Upload'
import { Box, Typography } from '@mui/material'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

function TariffListPage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`
  const navigate = useNavigate()

  const { tariffs, isFetching, totalResults, searchQueryParams, setSearchQueryParams } =
    useTariffsWithParams()
  const { setSelectedTariffId } = useContext(TariffContext)
  setSelectedTariffId('')

  const { searchText, handleChangePage, handleRequestSort, handleSearchTextChange, handleSearch } =
    useListFunctions({
      searchQueryParams,
      setSearchQueryParams
    })

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`
    }
  ]
  const [importDialogOpen, setImportDialogOpen] = useState(false)

  const handleImportDialogOpen = () => {
    setImportDialogOpen(true)
  }

  const handleImportDialogClose = () => {
    setImportDialogOpen(false)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Breadcrumbs items={breadcrumbs} />
      <Box sx={{ mb: 2 }}>
        <Typography variant="h1" sx={{ mb: 2 }}>{t`Tariffs`}</Typography>
        <Box mt={4}>
          <ListActions>
            <Box display="flex" gap={2}>
              <CustomButton
                onClick={() => navigate(`${baseUrl}/create/`)}
                size="small"
                startIcon={<AddIcon />}
              >
                {t`Create new tariff`}
              </CustomButton>
              {ENABLE_TARIFF_IMPORT && (
                <CustomButton
                  onClick={handleImportDialogOpen}
                  size="small"
                  startIcon={<UploadIcon />}
                >
                  {t`Import tariff`}
                </CustomButton>
              )}
            </Box>
            <ListSearch
              searchText={searchText}
              handleSearchTextChange={handleSearchTextChange}
              handleSearch={handleSearch}
              placeholder={t`Search by name or code`}
            />
          </ListActions>
          <TariffList
            rows={tariffs}
            isLoading={isFetching}
            params={searchQueryParams}
            handleRequestSort={handleRequestSort}
            handleChangePage={handleChangePage}
            count={totalResults}
            page={
              searchQueryParams.start_index
                ? Number.parseInt(searchQueryParams.start_index, 10) / ROWS_PER_PAGE_DEFAULT
                : 0
            }
          />
        </Box>
      </Box>
      {ENABLE_TARIFF_IMPORT && (
        <TariffImportDialog open={importDialogOpen} handleClose={handleImportDialogClose} />
      )}
    </Box>
  )
}

export default TariffListPage
